import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(private _auth: AuthService, private _router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    try {
      const allowedRoles = route.data['roles'];
      if (!this.isRoleList(allowedRoles) || allowedRoles.length === 0) {
        this.deny();
        return false;
      }

      if (!this._auth.isAuthenticated()) {
        this._router.navigate(['cliente/login']);
        return false;
      }

      const identity = this._auth.getIdentity();
      if (!identity) {
        this.deny();
        return false;
      }

      const roles = this._auth.getRoles();
      if (!this.isRoleList(roles)) {
        this.deny();
        return false;
      }

      if (!this._auth.isUserAllowed(allowedRoles)) {
        this.deny();
        return false;
      }

      return true;
    } catch {
      this.deny();
      return false;
    }
  }

  private isRoleList(value: unknown): value is number[] {
    return Array.isArray(value) && value.every((role) => typeof role === 'number');
  }

  private deny(): void {
    try {
      if (this._auth.isAuthenticated()) {
        this._router.navigate(['/perfil']);
        return;
      }
    } catch {
      // fail-closed: sin contexto válido de sesión, ir a login
    }

    this._router.navigate(['cliente/login']);
  }
}
